/* eslint-disable no-unused-vars */
import client from '@/apis/http-client'
import Vue from 'vue'
import moment from 'moment'
let pathUrl = `/por/api`
const pathOrgUrl = `sso/rbac/organization/permission`
import qs from 'qs'
var _ = require('lodash')

// Initial state.
const defaultState = () => {
  return {
    isLoading: false,
    isLoadingExport: false,
    digitalProductList: [],
    digitalProductCsv: '',
    orgObject: [],
    total: 0,
    // params
    currentPage: 1,
    pageSize: 25,
    textSearch: '',
    filterStatus: '',
    filterOrderDate: [],
    orgList: {
      all: [],
      selected: []
    },
    sortBy: 'update_date',
    sortDesc: 'DESC'
  }
}

// State
let state = defaultState()

function createParams(state) {
  const {
    currentPage,
    pageSize,
    textSearch,
    filterStatus,
    filterOrderDate,
    orgList,
    sortBy,
    sortDesc
  } = state

  const params = {
    lang: 'en',
    page: currentPage,
    limit: pageSize,
    q: `${encodeURIComponent(textSearch)}`,
    orderBy: sortBy,
    sort: sortDesc,
    ...(filterStatus && {status: filterStatus}),
    ...(filterOrderDate.length > 0 && {
      order_creation_start_date: filterOrderDate[0],
      order_creation_end_date: filterOrderDate[1]
    }),
    ...(orgList.selected.length > 0 && {
      org_codename: orgList.selected.map(o => o.codename)
    })
  }
  return params
}

// Actions
const actions = {
  // API calls
  async fetch({commit}) {
    commit('SET_IS_LOADING', true)
    const params = createParams(state)
    try {
      let data = await client.secureHttpClient.get(`${pathUrl}/products`, {
        params,
        paramsSerializer: params => qs.stringify(params, {encode: false})
      })

      commit('SET_TOTAL', data.data.total)
      commit('SET_DIGITAL_PRODUCT_LIST', data.data.data)
      commit('SET_IS_LOADING', false)
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_IS_LOADING', false)
    }
  },
  async fetchExportCsv({commit}) {
    let params = createParams(state)
    params = _.omit(params, 'page')
    params = _.omit(params, 'limit')
    params = {export: 'csv', ...params}
    commit('SET_IS_LOADING_EXPORT', true)

    try {
      let data = await client.secureHttpClient.get(
        `${pathUrl}/exports/products`,
        {
          params,
          paramsSerializer: params => qs.stringify(params, {encode: false})
        }
      )
      commit('SET_DIGITAL_PRODUCT_CSV', data.data.data)
      commit('SET_IS_LOADING_EXPORT', false)
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_IS_LOADING_EXPORT', false)
    }
  },
  async editPackageStatus({commit}, data) {
    commit('SET_IS_LOADING', true)
    const {id, selectedReason, newStatus, reasonNote, validityEndDate} = data
    const payload = {
      edit_reason: selectedReason,
      reason_note: reasonNote,
      status: newStatus,
      renew_at: moment(new Date()),
      ...(validityEndDate !== null && {validity_end_date: validityEndDate})
    }

    try {
      await client.secureHttpClient.put(
        `${pathUrl}/products/${id}/change-package-status`,
        payload
      )
      commit('SET_IS_LOADING', false)
      return true
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_IS_LOADING', false)
      return false
    }
  },
  resetList({commit}) {
    commit('RESET_LIST_STATE')
  },
  setFieldSort({commit}, field) {
    if (field) {
      commit('SET_FIELD_SORT', field)
    } else {
      commit('SET_FIELD_SORT', defaultState().sortBy)
    }
  },
  async setListOrgInfo({commit}) {
    commit('SET_IS_LOADING', true)
    let data = await client.secureHttpClient.get(
      `${pathOrgUrl}?permission=View&category=OrderPackage`
    )
    commit('SET_ORG_FILTER', data.data)
    commit('SET_IS_LOADING', false)
  },
  setPage({commit}, page) {
    commit('SET_PAGE', page)
  },
  setPageSize({commit}, size) {
    commit('SET_PAGE_SIZE', size)
  },
  setSort({commit}, sort) {
    commit('SET_SORT', sort === undefined ? 'DESC' : sort ? 'DESC' : 'ASC')
  },
  setTextSearch({commit}, text) {
    if (text === state.textSearch) return
    commit('SET_TEXT_SEARCH', text)
  },
  setFilterStatus({commit}, listStatus) {
    commit('SET_FILTER_STATUS', listStatus)
  },
  setFilterOrderDate({commit}, orderDates) {
    commit('SET_FILTER_ORDER_DATE', orderDates)
  }
}

// Mutations
const mutations = {
  RESET_LIST_STATE(state) {
    state.textSearch = defaultState().textSearch
    state.filterStatus = defaultState().filterStatus
    state.filterOrderDate = defaultState().filterOrderDate
    state.orgList = defaultState().orgList
    state.sortBy = defaultState().sortBy
    state.sortDesc = defaultState().sortDesc
  },
  SET_FIELD_SORT(state, field) {
    state.sortBy = field
  },
  SET_IS_LOADING(state, isLoading) {
    state.isLoading = isLoading
  },
  SET_IS_LOADING_EXPORT(state, isLoadingExport) {
    state.isLoadingExport = isLoadingExport
  },
  SET_TEXT_SEARCH(state, text) {
    state.textSearch = text
  },
  SET_TOTAL(state, total) {
    state.total = total
  },
  SET_DIGITAL_PRODUCT_LIST(state, orders) {
    state.digitalProductList = orders
  },
  SET_DIGITAL_PRODUCT_CSV(state, csv) {
    state.digitalProductCsv = csv
  },
  SET_ORG_FILTER(state, org) {
    const selected = []

    if (org.data.length === 1) {
      org.data.forEach(d =>
        selected.push({
          codename: d.codename,
          selected: true
        })
      )
    }
    state.orgList.selected = selected
    state.orgList.all = org.data
  },
  SET_PAGE(state, page) {
    state.currentPage = page
  },
  SET_PAGE_SIZE(state, size) {
    state.pageSize = size
  },
  SET_SORT(state, sort) {
    state.sortDesc = sort
  },
  SET_FILTER_STATUS(state, listStatus) {
    state.filterStatus = listStatus
  },
  SET_FILTER_ORDER_DATE(state, orderDates) {
    state.filterOrderDate = orderDates
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
